import { render, staticRenderFns } from "./LatestViewedSlider.vue?vue&type=template&id=16fcb530&scoped=true&"
import script from "./LatestViewedSlider.vue?vue&type=script&lang=js&"
export * from "./LatestViewedSlider.vue?vue&type=script&lang=js&"
import style0 from "./LatestViewedSlider.vue?vue&type=style&index=0&id=16fcb530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fcb530",
  null
  
)

export default component.exports